export const LoansHeaderImageMobile = () => (
  <svg
    width="320"
    height="240"
    viewBox="0 0 320 240"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', height: '100%' }}
  >
    <g clipPath="url(#clip0_188_8854)">
      <g clipPath="url(#clip1_188_8854)">
        <rect
          width="320"
          height="600"
          transform="translate(0 -201)"
          fill="url(#paint0_linear_188_8854)"
        />
        <rect
          opacity="0.8"
          x="334.188"
          y="267.288"
          width="300.703"
          height="718.363"
          transform="rotate(130.933 334.188 267.288)"
          fill="url(#paint1_linear_188_8854)"
        />
        <rect x="-1" y="-110" width="321" height="350" fill="#031635" />
        <rect
          opacity="0.8"
          x="334.188"
          y="267.288"
          width="300.703"
          height="718.363"
          transform="rotate(130.933 334.188 267.288)"
          fill="url(#paint2_linear_188_8854)"
        />
        <rect
          x="322.631"
          y="123.778"
          width="164.504"
          height="449.713"
          transform="rotate(41.2559 322.631 123.778)"
          fill="url(#paint3_linear_188_8854)"
          fillOpacity="0.9"
        />
        <path
          opacity="0.2"
          d="M82.6185 398.856L277.031 175.473L331.222 115.335L278.491 176.743L84.0787 400.127L34.0143 456.177L82.6185 398.856Z"
          fill="url(#paint4_linear_188_8854)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_188_8854"
        x1="160"
        y1="0"
        x2="160"
        y2="600"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity="0" />
        <stop offset="0.460115" stopOpacity="0.01" />
        <stop offset="0.61541" stopOpacity="0.75" />
        <stop offset="0.845558" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_188_8854"
        x1="491.379"
        y1="320.615"
        x2="512.828"
        y2="747.711"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0E62EA" stopOpacity="0.71" />
        <stop offset="1" stopColor="#022A69" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_188_8854"
        x1="491.379"
        y1="320.615"
        x2="512.828"
        y2="747.711"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0E62EA" stopOpacity="0.71" />
        <stop offset="1" stopColor="#022A69" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_188_8854"
        x1="331.512"
        y1="231.346"
        x2="518.323"
        y2="453.712"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1E6DEB" />
        <stop offset="1" stopColor="#003485" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_188_8854"
        x1="74.954"
        y1="409.144"
        x2="308.289"
        y2="141.038"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_188_8854">
        <rect width="320" height="240" fill="white" />
      </clipPath>
      <clipPath id="clip1_188_8854">
        <rect width="320" height="600" fill="white" transform="translate(0 -201)" />
      </clipPath>
    </defs>
  </svg>
);
